/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-21 19:27:04
 * @LastEditors: changfeng
 * @LastEditTime: 2024-07-11 16:27:09
 */
import http from "@/api";

export const fetchstrategyList = params => {
	return http.get("/adv/strategy/list", params);
};

export const fetchEditRules = params => {
	return http.post("/adv/strategy/update", params);
};

export const fetchDeleteStrategy = params => {
	return http.get("/adv/strategy/remove", params);
};

export const fetchCreateStrategy = params => {
	return http.post("/adv/strategy/create", params);
};
export const fetchStrategyMarketList = params => {
	return http.get("/adv/strategy/store", params);
};

export const fetchStrategyStatus = (params: { status: number; strategyId: number }) => {
	return http.post("/adv/strategy/update/status", params);
};

export const fetchStrategyDetail = (params, code) => {
	return http.get(`/adv/strategy/${params}`, {
		id: params,
		shareCode: code
	});
};

export const fetchStartegyActionLog = params => {
	return http.get(`/adv/strategy/action/log`, params);
};

export const fetchStrategyDragSort = params => {
	return http.post("/adv/strategy/update/sort", params);
};

/** 批量绑定策略 */
export const fetchBatchBindingStrategyWidthAdv = params => {
	return http.post("/adv/strategy/batch/binding/strategy", params);
};
